<template>
  <v-radio-group
    v-model="radio"
    :row="row"
    class="input-radio mt-0"
    v-bind="$attrs"
    :rules="rules"
  >
    <v-radio
      v-for="option in options"
      :key="option.value"
      :value="option.value"
      :color="option.color || 'success'"
      :label="option.label"
      :disabled="disabled"
      class="pr-3"
    />
  </v-radio-group>
</template>

<script>
export default {
  name: 'InputRadio',
  props: {
    value: {
      type: [String, Number, Boolean],
      default: '',
    },
    options: {
      type: Array,
      default() {
        return [];
      },
    },
    row: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
    rules: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    radio: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>

<style>
  .input-radio .v-radio {
      padding: 10px;
      border: 1px solid #E0E0E0;
      border-radius: 4px;
    }

    .v-radio.success--text{
      background: #EAFAF5;
      border-color: #EAFAF5;
    }

    .v-radio.success--text .v-label{
      color: #3EBD93;
    }

</style>
